module.exports = __webpack_public_path__ + "static/media/pen.93a5d539.png";